<template>
  <div class="iq-card">
    <div class="iq-card-header d-flex justify-content-between pt-2">
      <div class="iq-header-title">
        <h5 class="card-title">{{ title }}</h5>
        <span class="text-muted m-sm-0">Last Updated {{ lastUpdated }}</span>
      </div>
    </div>
    <div class="iq-card-body pt-0">
      <div class="row mt-2">
        <div class="col-12 p-0 rpm-chart-wrapper">
          <apexchart
            :element="elementId"
            :options="rpmChart"
            :series="[rpmSeries]"
          />
          <b-row>
            <b-col>
              <p class="chart-title">Engine Hour</p>
              <p class="chart-info"><b>{{ runningTime }}</b></p>
            </b-col>
            <b-col>
              <p class="chart-title">Average RPM</p>
              <p class="chart-info"><b>{{ average }}</b></p>
            </b-col>
            <div v-if="showExhaust">
              <p class="chart-title">Exhaust Temp</p>
              <p class="chart-info"><b>{{ exhaust }}</b> °C</p>
            </div>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EngineSummaryCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    lastUpdated: {
      type: String,
      default: '-',
    },
    rpmChart: {
      type: Object,
      required: true,
    },
    rpmSeries: {
      type: [String, Number],
      default: 0,
    },
    runningTime: {
      type: String,
      default: '-',
    },
    average: {
      type: [String, Number],
      default: '-',
    },
    exhaust: {
      type: [String, Number],
      default: '-',
    },
    showExhaust: {
      type: Boolean,
      default: false,
    },
    elementId: {
      type: String,
      default: 'chart-14',
    },
  },
};
</script>

<style scoped>
.chart-title {
  font-size: 1rem;
  color: #2c3e50;
  margin: 0;
  text-align: center;
}

.chart-info {
  font-size: 1.5625rem;
  color: #0084ff;
  margin: 0;
  text-align: center;
}

@media screen and (max-width: 991px) {
  .chart-title {
    font-size: 0.75rem;
  }

  .rpm-chart-wrapper {
    display: none;
  }
}
</style>
